import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';

const advantages = [
  {
    title: "Factories & Plants",
    description: "Predict failures before they happen, optimize equipment schedules, and visualize system-wide KPIs.",
  },
  {
    title: "OEMs & Equipment Vendors",
    description: "Embed Edge AI within industrial sensors and monitoring devices for on-site fault analytics.",
  },
  {
    title: "Energy-Intensive Industries",
    description: "Use predictive maintenance to prevent outages, forecast usage, and streamline load balancing.",
  },
  {
    title: "EV Infrastructure Providers",
    description: "Integrate V2G forecasting models into charging systems to enable bidirectional energy flow.",
  },
  {
    title: "IoT Platform Vendors",
    description: "Seamlessly connect our AI stack via APIs or SDKs for intelligent system orchestration.",
  },
  {
    title: "R&D Institutions",
    description: "Partner on real-time microgrid AI, hydrogen system modeling, and predictive analytics research.",
  },
]

const Advantage = () => {
  return (
    <>
      <Element
        name="Advantage"
        className="datatalent-section-gap solutions-advantage"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center text-white"
                title = "Manufacturing Ecosystem Integration"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center color-white">AI-Powered Value Across the Manufacturing Chain.</p>
            </div>
            {advantages.map((adv) =>
              <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={adv.title}>
                <div className="advantage-card p-4 h-100">
                  <h5 className="mt-3 mb-3 color-white">{adv.title}</h5>
                  <p className="mb-3">{adv.description}</p>
                </div>
            </div>
            )}
          </div>
        </div>
      </Element>
    </>
  )
}

export default Advantage;